document.addEventListener('DOMContentLoaded', function () {
  const collapsibleButtons = document.querySelectorAll('.collapsible-button')

  collapsibleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      console.log('collapsible clicked');
      const content = button.nextElementSibling
      const caretIcon = button.querySelector('.caret-icon')

      const isOpen = content.classList.contains('max-h-[600px]')

      // Close all open contents and reset caret icons
      const otherCollapsibleRows = document.querySelectorAll('.collapsible-row')

      otherCollapsibleRows.forEach(function (row) {
        const otherContent = row.querySelector('.collapsible-content')
        const otherCaretIcon = row.querySelector('.caret-icon')

        if (otherContent !== content && otherContent) {
          otherContent.classList.remove('max-h-[600px]')
          otherContent.classList.remove('pb-4')
          otherContent.classList.add('max-h-0')
          otherCaretIcon.classList.remove('rotate-180')
        }
      })

      if (!isOpen) {
        content.classList.remove('max-h-0')
        content.classList.add('max-h-[600px]')
        caretIcon.classList.add('rotate-180')
        content.classList.add('pb-4')
      } else {
        content.classList.remove('max-h-[600px]')
        content.classList.add('max-h-0')
        content.classList.remove('pb-4')
        caretIcon.classList.remove('rotate-180')
      }
    })
  })
})

class CrossSellDrawer extends HTMLElement {
  constructor() {
    super();
    this.state = {
      isVisible: false,
      title: '',
      subtitle: '',
      description: '',
      image: '',
      link: '',
      primaryButton: {
        text: '제품 보러가기',
        onClick: null
      },
      secondaryButton: {
        text: '쇼핑 계속하기',
        onClick: null
      }
    };
    this.render = this.render.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    this.unsubscribeOpen = window.eventBus.subscribe('cross-sell-drawer:open', this.handleOpen);
    this.unsubscribeClose = window.eventBus.subscribe('cross-sell-drawer:close', this.handleClose);
    this.addEventListener('click', this.handleClick.bind(this));
  }

  removeEventListeners() {
    this.unsubscribeOpen();
    this.unsubscribeClose();
    this.removeEventListener('click', this.handleClick);
  }

  setState(newState) {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  handleClick(event) {
    const closeButton = event.target.closest('button[name="close"]');
    const overlay = event.target.closest('cross-sell-drawer-overlay');
    const primaryButton = event.target.closest('#primary-button');
    const secondaryButton = event.target.closest('#secondary-button');

    if (closeButton || overlay) {
      this.handleClose();
    } else if (primaryButton) {
      this.handleButtonClick(this.state.primaryButton.onClick);
    } else if (secondaryButton) {
      this.handleButtonClick(this.state.secondaryButton.onClick);
    }
  }

  handleButtonClick(onClick) {
    if (onClick && typeof onClick === 'function') {
      onClick(this.state, this.handleClose.bind(this));
    }
  }

  handleOpen(data) {
    this.setState({
      isVisible: true,
      title: data.title || '',
      subtitle: data.subtitle || '',
      description: data.drawerDescription || '',
      image: data.image || '',
      link: data.link || '',
      primaryButton: {
        ...this.state.primaryButton,
        ...data.primaryButton
      },
      secondaryButton: {
        ...this.state.secondaryButton,
        ...data.secondaryButton
      }
    });
  }

  handleClose() {
    this.setState({ isVisible: false });
  }

  render() {
    const { isVisible, title, subtitle, description, image, primaryButton, secondaryButton } = this.state;

    this.innerHTML = `
      <div class="fixed left-0 top-0 flex justify-end w-[100vw] h-full ${isVisible ? '!visible' : 'invisible'} bg-[#12121280] transition-all" style="z-index: 1000;">
        <cross-sell-drawer-overlay class="block fixed top-0 right-0 bottom-0 left-0"></cross-sell-drawer-overlay>
        <div class="flex flex-col justify-between md:w-[36rem] md:max-w-[calc(100vw_-_3rem)] bg-white overflow-hidden transition-all h-[85vh] absolute w-full bottom-0 md:relative md:h-full rounded-tl-lg rounded-tr-lg md:rounded-none transform ${isVisible ? '!translate-y-0 md:!translate-x-0' : 'translate-y-full md:translate-x-full'}">
          <div class="flex flex-col h-full">
            <div class="p-4 md:py-4 md:px-6 flex items-center border-[#B0B1C2] border-b">
              <div class="w-full">
                <h2 class="text-[16px] md:text-[20px] mb-1 md:mb-2 font-semibold font-inter block">${title}</h2>
                <p class="block line-clamp-2">${subtitle}</p>
              </div>
              <button name="close" class="rounded-full w-10 h-10 transform rotate-45">
                <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="#2E2F3C" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="#2E2F3C"></path>
                </svg>
              </button>
            </div>
            <div class="p-4 md:px-6 md:py-6 mb-auto overflow-auto">
              <img class="rounded-lg mb-4 md:mb-5" loading="lazy" src="${image}" alt="">
              <div class="cross-sell-drawer-richtext">${description}</div>
            </div>
            <div class="p-4 md:px-6 md:py-4 border-[#B0B1C2] border-t">
              <div class="flex gap-2">
                <button id="secondary-button" class="font-inter text-[16px] md:text-[20px] font-semibold flex-1 text-center text-[#FFA236] bg-white rounded-full border-[#FFA236] border-2">${secondaryButton.text}</button>
                <button id="primary-button" class="btn text-[16px] md:text-[20px] flex-1">${primaryButton.text}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('cross-sell-drawer', CrossSellDrawer);

class BPIDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    this.unsubscribeOpen = window.eventBus.subscribe('bpi-drawer:open', this.handleOpen);
    this.unsubscribeClose = window.eventBus.subscribe('bpi-drawer:close', this.handleClose);
    this.addEventListener('click', this.handleClick.bind(this));
  }

  removeEventListeners() {
    this.unsubscribeOpen();
    this.unsubscribeClose();
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const closeButton = event.target.closest('button[name="close"]');
    const overlay = event.target.closest('bpi-drawer-overlay');
    const primaryButton = event.target.closest('#primary-button');

    if (closeButton || primaryButton || overlay) {
      this.handleClose();
    }
  }

  handleOpen() {
    this.classList.remove('hidden')
    this.classList.add('flex')
  }

  handleClose() {
    this.classList.remove('flex')
    this.classList.add('hidden')
  }
}

customElements.define('bpi-drawer', BPIDrawer);

class VariantSelector extends CustomElement {
  props = {
    value: null,
    options: []
  };

  constructor() {
    super();

    this.changeEvent = new Event('change')
  }

  get refs() {
    return {
      $select: this.$el.find('select')
    }
  }

  render() {
    const { value, options } = this.props

    const availOptions = options.filter(({ available }) => !!available);

    const template = `
    <select>
      ${options.map(o => `<option ${value === o.id ? 'selected' : ""} ${!o.available ? 'disabled' : ''} data-price="${o.price / 100}" data-original-price="${o.compare_at_price / 100}" data-sku="${o.sku}" value="${o.id}">${o.title}</option>`).join("")}
    </select>`

    this.innerHTML = template
  }

  async mounted() {
    const { $select } = this.refs

    $select.change(this.handleSelectVariant.bind(this))

    await ResourceCoordinator.requestVendor('Select2');

    $select.select2({
      minimumResultsForSearch: -1,
      dropdownAutoWidth: true,
      width: 'auto'
    });

    const selectElm = $select[0].closest('label')?.querySelector('svg') || $select[0].querySelector('svg') || $select[0].querySelector('select') || $select[0];

    selectElm?.addEventListener('click', () => {
      $select.select2('open');
    });
  }

  onDisabledChange(isDisabled) {
    super.onDisabledChange(isDisabled);

    const { $select } = this.refs

    $select.attr('disabled', !!isDisabled)
  }

  handleSelectVariant(e) {
    this.dispatchEvent(this.changeEvent);
  }

  selectVariant(value) {
    const { $select } = this.refs
    $select.val(value).trigger('change');
  }
}

customElements.define('variant-selector', VariantSelector);


class CartVariantSelector extends VariantSelector {
  props = {
    value: null,
    options: [],
    quantity: 0,
    key: 0
  };

  async handleSelectVariant(e) {
    super.handleSelectVariant(e);

    const { key, quantity } = this.props

    const $selectedOption = $(this).find(':selected')
    const variantId = $selectedOption.val()


    await this.closest('cart-drawer-items').switchVariant(variantId, quantity, key);
  }

}

customElements.define('cart-variant-selector', CartVariantSelector);

class QuantityAdjusterButton extends CustomButton {
  props = {
    size: null, name: ""
  };
  
  render() {
    const {name, size} = this.props
    
    const template = `
        <svg class="border-2 border-[#2E2F3C] rounded-full" width="${size}" height="${size}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          ${name === 'plus' ? `
                <path d="M10 6.66699V13.3337" stroke="#2E2F3C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.66699 10H13.3337" stroke="#2E2F3C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />` : `
              <path d="M6.66699 10H13.3337" stroke="#2E2F3C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            `}
      </svg>
    `;
    
    this.$el.html(template)
  }
  
  onDisabledChange(isDisabled) {
    this.$el[!!isDisabled ? 'addClass' : 'removeClass']('is-disabled')
  }
}

customElements.define('quantity-adjuster-button', QuantityAdjusterButton);


class QuantityAdjuster extends CustomElement {
  props = {
    index: 0, size: 36, min: 1, max: null, inventoryPolicy: ""
  };
  
  get refs() {
    return {
      minusBtn: this.querySelector(`quantity-adjuster-button[\\:name=minus]`),
      plusBtn : this.querySelector(`quantity-adjuster-button[\\:name=plus]`)
    }
  }
  
  beforeMount() {
    const {index} = this.props
    
    this.changeEvent = new Event('change', {bubbles: true})
    
    this.$el.addClass("quantity-adjuster")
    this.$el.attr('id', `Drawer-quantity-${index + 1}`)
    this.$el.attr('name', "updates[]")
    this.$el.attr('data-index', index + 1)
  }
  
  async mounted() {
    this.$val = this.$el.find('.quantity-adjuster__value');
    
    this.checkThreshold(this.value)
    
    this.$el.find('quantity-adjuster-button').click((e => {
      e.preventDefault();
      
      this.onButtonClick($(e.currentTarget))
    }));

    await ResourceCoordinator.requestVendor('TippyDependency')
    await ResourceCoordinator.requestVendor('Tippy');
    
    tippy('quantity-adjuster-button.is-disabled[\\:name=plus]', {
      content: "Out of stock",
    });
  }
  
  onValueChange(val) {
    const isExceed = this.checkThreshold(val)
    
    if (isExceed) return
    
    this.$val?.text(val);
  }
  
  checkThreshold(val) {
    const {min, max, inventoryPolicy} = this.props;
    const {minusBtn, plusBtn}         = this.refs
    
    if (!minusBtn || !plusBtn) return
    
    if (inventoryPolicy === 'continue') return true
    
    const minThresholdExceed = isNumber(min) && val <= min
    const maxThresholdExceed = isNumber(max) && val >= max
    
    minusBtn.disabled = !!minThresholdExceed
    plusBtn.disabled  = !!maxThresholdExceed
    
    if (minThresholdExceed || maxThresholdExceed) {
      this.value = Math.min(Math.max(val, min), max)
      
      return false
    }
    
    return true
  }
  
  render() {
    const {size} = this.props
    
    const template = `
        <quantity-adjuster-button :name="minus" :size="${size}"></quantity-adjuster-button>
        <p class="quantity-adjuster__value">${this.value}</p>
        <quantity-adjuster-button :name="plus" :size="${size}"></quantity-adjuster-button>
    `;
    
    this.$el.html(template)
  }
  
  onButtonClick($button) {
    const previousValue = this.$val.text();
    
    this.value = $button.attr(':name') === 'plus' ? +this.value + 1 : +this.value - 1;
    
    if (+previousValue !== +this.value) this.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-adjuster', QuantityAdjuster);

class CountdownTimer extends CustomElement {
  props = {
    targetDate: '',
    title: '',
    minimal: false,
    size: '',
  }

  constructor() {
    super()
  }

  template() {
    super.template()

    const { title, minimal } = this.props

    return `
      ${title ? `<p class="paragraph-14 font-semibold text-white md:text-black">${title}</p>` : ''}
      <div class="timer-display${minimal ? ' is-minimal' : ''}">
        <div class="time-part">
          <p class="digit"></p>
          <p class="label">Days</p>
        </div>
        <div class="time-part">
          <p class="digit"></p>
          <p class="label">Hours</p>
        </div>
        <div class="time-part">
          <p class="digit"></p>
          <p class="label">Minutes</p>
        </div>
        <div class="time-part">
          <p class="digit"></p>
          <p class="label">Seconds</p>
        </div>
      </div>
    `
  }

  tick(delta) {
    if (delta < 0) {
      this.remove()
      return
    }

    const { minimal } = this.props

    const timeParts = getTimeParts(delta)

    if (minimal) {
      const partLabels = ['days', 'hours', 'minutes', 'seconds']

      $(this).find('.timer-display').html(timeParts.map((digit, i) => `<div><b>${digit}</b> ${partLabels[i]}</div>`).join(' '))
    } else {
      this.$el.find('.time-part').each(function (i) {

        $(this).find('.digit').text(timeParts[i])
      })
    }

  }

  mounted() {
    super.mounted()

    const { targetDate } = this.props

    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))

    let delta = (endTime - startTime) / 1000

    if (delta > 0) {
      this.style.display = 'block'
    }

    this.tick(delta)

    setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)
  }
}

customElements.define('countdown-timer', CountdownTimer)

class CountdownTimerAnnouncement extends CustomElement {
  props = {
    targetDate: '',
    title: '',
    minimal: false,
    size: '',
  }

  constructor() {
    super()
  }

  template() {
    super.template()

    const { title, minimal } = this.props

    return `
      ${title ? `<p class="paragraph-14 font-semibold text-white md:text-black">${title}</p>` : ''}
      <div class="md:!flex text-[12px] md:!text-[14px] font-normal timer-display${minimal ? ' is-minimal' : ''}">
        <div class="time-part">

          <p class="text-[12px] md:!text-[14px]">종료까지</p>
          <p class="digit text-[12px] md:!text-[14px]"></p>
          <p class="label text-[12px] md:!text-[14px]">일</p>
        </div>
        <div class="time-part">
          <p class="digit text-[12px] md:!text-[14px]"></p>
          <p class="label text-[12px] md:!text-[14px]">시간</p>
        </div>
        <div class="time-part">
          <p class="digit text-[12px] md:!text-[14px]"></p>
          <p class="label text-[12px] md:!text-[14px]">분</p>
        </div>
        <div class="time-part">
          <p class="digit text-[12px] md:!text-[14px]"></p>
          <p class="label text-[12px] md:!text-[14px]">초</p>
        </div>
      </div>
    `
  }

  tick(delta) {
    if (delta < 0) {
      this.remove()
      return
    }

    const { minimal } = this.props

    const timeParts = getTimeParts(delta)

    if (minimal) {
      const partLabels = ['days', 'hours', 'minutes', 'seconds']

      $(this).find('.timer-display').html(timeParts.map((digit, i) => `<div><b>${digit}</b> ${partLabels[i]}</div>`).join(' '))
    } else {
      this.$el.find('.time-part').each(function (i) {

        $(this).find('.digit').text(timeParts[i])
      })
    }

  }

  mounted() {
    super.mounted()

    const { targetDate } = this.props

    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))

    let delta = (endTime - startTime) / 1000

    if (delta > 0) {
      this.style.display = 'block'
    }

    this.tick(delta)

    setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)
  }
}

customElements.define('countdown-timer-announcement', CountdownTimerAnnouncement)

class StarRating extends HTMLElement {
  constructor() {
    super()
    this.props = { rating: 0, size: 13 }
    this.maxRating = 5
    this.minRating = 1
  }

  get star() {
    return `
      <svg class="mr-[2px]" width="${this.props.size}" height="${this.props.size}" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 8.10006C20.1 7.60006 19.7 7.00006 19.2 7.00006L13.5 6.20006L10.9 1.00006C10.8 0.800061 10.7 0.70006 10.5 0.60006C10 0.30006 9.4 0.50006 9.1 1.00006L6.6 6.20006L0.9 7.00006C0.6 7.00006 0.4 7.10006 0.3 7.30006C-0.1 7.70006 -0.1 8.30006 0.3 8.70006L4.4 12.7001L3.4 18.4001C3.4 18.6001 3.4 18.8001 3.5 19.0001C3.8 19.5001 4.4 19.7001 4.9 19.4001L10 16.7001L15.1 19.4001C15.2 19.5001 15.4 19.5001 15.6 19.5001C15.7 19.5001 15.7 19.5001 15.8 19.5001C16.3 19.4001 16.7 18.9001 16.6 18.3001L15.6 12.6001L19.7 8.60006C19.9 8.50006 20 8.30006 20 8.10006Z" fill="#F9D040"/>
      </svg>
    `
  }

  get emptyStar() {
    return `
      <svg class="mr-[2px]" width="${this.props.size}" height="${this.props.size}" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 7.67002C19.9368 7.48711 19.822 7.32645 19.6693 7.20753C19.5167 7.0886 19.3328 7.01652 19.14 7.00002L13.45 6.17002L10.9 1.00002C10.8181 0.830952 10.6902 0.688365 10.5311 0.588597C10.3719 0.488828 10.1878 0.435913 9.99998 0.435913C9.81212 0.435913 9.62806 0.488828 9.46889 0.588597C9.30971 0.688365 9.18186 0.830952 9.09998 1.00002L6.54998 6.16002L0.859977 7.00002C0.6749 7.02633 0.500902 7.10399 0.357728 7.22418C0.214554 7.34438 0.107937 7.5023 0.0499774 7.68002C-0.00307759 7.8537 -0.00783865 8.03854 0.0362052 8.21472C0.080249 8.39089 0.171435 8.55175 0.299977 8.68002L4.42998 12.68L3.42998 18.36C3.39428 18.5475 3.41297 18.7413 3.48385 18.9185C3.55473 19.0957 3.67483 19.2489 3.82998 19.36C3.98119 19.4681 4.15955 19.5319 4.34503 19.5443C4.5305 19.5567 4.71575 19.5171 4.87998 19.43L9.99998 16.76L15.1 19.44C15.2403 19.5192 15.3988 19.5606 15.56 19.56C15.7718 19.5608 15.9784 19.4942 16.15 19.37C16.3051 19.2589 16.4252 19.1057 16.4961 18.9285C16.567 18.7513 16.5857 18.5575 16.55 18.37L15.55 12.69L19.68 8.69002C19.8244 8.5677 19.9311 8.40693 19.9877 8.22637C20.0444 8.04582 20.0486 7.8529 20 7.67002ZM13.85 11.67C13.7327 11.7835 13.645 11.9239 13.5944 12.079C13.5439 12.2341 13.532 12.3993 13.56 12.56L14.28 16.75L10.52 14.75C10.3753 14.673 10.2139 14.6327 10.05 14.6327C9.88606 14.6327 9.72466 14.673 9.57998 14.75L5.81998 16.75L6.53998 12.56C6.56791 12.3993 6.55609 12.2341 6.50554 12.079C6.45499 11.9239 6.36725 11.7835 6.24998 11.67L3.24998 8.67002L7.45998 8.06002C7.62198 8.03749 7.77598 7.97556 7.90848 7.87967C8.04098 7.78379 8.14794 7.65686 8.21998 7.51002L9.99998 3.70002L11.88 7.52002C11.952 7.66686 12.059 7.79379 12.1915 7.88968C12.324 7.98556 12.478 8.04749 12.64 8.07002L16.85 8.68002L13.85 11.67Z" fill="#B1B1B1"/>
      </svg>
    `
  }

  initProps() {
    this.props.rating = +this.getAttribute(':rating') ?? this.maxRating
    this.props.size = this.getAttribute(':size') ?? '13'
  }

  connectedCallback() {
    this.initProps()
    this.render()
  }

  disconnectedCallback() {
  }

  render() {
    const ratingTemplate = this.getRatingTemplate(this.props.rating <= this.maxRating ? this.props.rating : this.maxRating)
    const wrapper = document.createElement('div')
    wrapper.className = 'flex items-center mb-[1px]'
    wrapper.innerHTML = ratingTemplate
    this.appendChild(wrapper)
  }

  getRatingTemplate(rating) {
    let result = ''
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        result += this.star
      } else {
        result += this.emptyStar
      }
    }
    return result
  }
}

customElements.define('star-rating', StarRating)
